import { Button, Flex, Typography } from 'antd';

import DiscardChangesButton from '@/components/DiscardChangesButton';

import type { ItemNoun } from '../../types';

import { DEFAULT_ITEM_NOUN } from './constants';

type Props = {
  count: number;
  onCancel: () => void;
  onSave: () => void;
  isSaving?: boolean;
  disabled?: boolean;
  itemNoun?: ItemNoun;
};

const UnsavedChangesBar = ({
  count,
  onCancel,
  onSave,
  isSaving,
  disabled,
  itemNoun = DEFAULT_ITEM_NOUN
}: Props) => (
  <Flex align='center' gap={16}>
    <Typography.Text type='secondary'>
      {count} {count === 1 ? itemNoun.singular : itemNoun.plural} unsaved
    </Typography.Text>
    <Flex gap={8}>
      <DiscardChangesButton
        onDiscardChanges={onCancel}
        showConfirmationModal
        disabled={isSaving}
      />
      <Button
        type='primary'
        loading={isSaving}
        disabled={disabled}
        onClick={onSave}>
        Save
      </Button>
    </Flex>
  </Flex>
);

export default UnsavedChangesBar;
